/* eslint-disable jsx-a11y/control-has-associated-label */
import WalletControls from "components/molecules/WalletControls";

import "./styles.sass";

type UserControlsAuthProps = {
  balance: number;
  bonus: number;
};

const UserControlsAuth = (props: UserControlsAuthProps) => {
  const { balance, bonus } = props;

  return (
    <div className="UserControlsAuth" data-cy="user-controls">
      <WalletControls bonus={bonus} balance={balance} />
    </div>
  );
};

export default UserControlsAuth;
